import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@mui/material';
import ListaHistorico from './ListaHistorico';

/**
 * Pop-up "Expandir Histórico" — port do padrão real já documentado em
 * `docs/architecture/AW2-189-expandir-historico.md`: mesmo `historicos` já
 * carregado pela aba (sem fetch novo), scroll-infinito continua funcional
 * (`onScrollFim` repassado), altura ampliada (650px lá, aqui um pouco maior
 * para compensar o padding do `DialogContent`), somente leitura.
 *
 * **Dupla barreira contra mutação dentro do pop-up** (mesmo padrão real —
 * `isDisbaledChangePin={true}` + `onChangeChecked={() => {}}`): aqui,
 * `desabilitarFixar` fixo em `true` (desabilita a UI) + `onFixarHistorico`
 * fixo num no-op local (não dispara nenhuma chamada) — não repassa o
 * `onFixarHistorico` real da aba, mesmo que o chamador o tenha disponível.
 *
 * MUI `Dialog` já desmonta os filhos ao fechar por padrão (`keepMounted`
 * não setado) — diferente dos dialogs "sempre montados" documentados em
 * `src/prototipo/CLAUDE.md` (que precisam de guardas de sessão/reset
 * manuais), este componente não guarda nenhum estado próprio entre
 * aberturas, então não há nada para vazar de uma sessão para a próxima.
 */
const NAO_OPERAR = () => {};

export default function DialogExpandirHistorico({
  open, onClose, historicos, carregandoMais, onScrollFim,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Histórico</DialogTitle>
      <DialogContent>
        <ListaHistorico
          historicos={historicos}
          carregandoMais={carregandoMais}
          desabilitarFixar
          onFixarHistorico={NAO_OPERAR}
          onScrollFim={onScrollFim}
          altura={680}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">OK</Button>
      </DialogActions>
    </Dialog>
  );
}
DialogExpandirHistorico.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  historicos: PropTypes.shape({
    content: PropTypes.array,
    last: PropTypes.bool,
  }),
  carregandoMais: PropTypes.bool,
  onScrollFim: PropTypes.func.isRequired,
};
DialogExpandirHistorico.defaultProps = {
  open: false,
  historicos: null,
  carregandoMais: false,
};
